import TextTransformer from "../html/TextTransformer";
import HebrewDefinitionLookup from "./HebrewDefinitionLookup";

export default class HebrewDefinitionTransformer implements TextTransformer {

    public constructor(private readonly definitions: HebrewDefinitionLookup,
        private readonly mainDefinitionOnly: boolean) {
    }

    public transformText(text: string): string {
        const definitions = this.mainDefinitionOnly ?
            [this.definitions.getMainDefinition(text)] :
            this.definitions.getDefinitions(text);
        return definitions.length > 0 ? definitions.join(', ') : '?';
    }
}
